/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_Gericht_700px.jpg";
import Typography from "@mui/material/Typography";
import { Paper } from "@mui/material";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookDivorceCourtHearing = () => {
  const title = "Ratgeber - Gerichtstermin | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content="Wie verläuft der Scheidungstermin vor Gericht und was müssen Sie beachten? Wir bereiten Sie vor." />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan slogan={"Perfekt informiert zum Scheidungstermin"} backgroundImagePath={backgroundTeaser} height={300} headingColor={"#333333"} />
        <TextContainer>
          <p>
            Sie sind fast am Ziel: das Gericht hat Ihnen einen Scheidungstermin zugewiesen. Doch wie verläuft der Termin vor Gericht und was müssen Sie
            beachten? Damit Sie perfekt vorbereitet sind, haben wir Ihnen hier alle wichtigen Informationen zu Ihrem Scheidungstermin zusammengestellt.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Was Sie mitbringen müssen
          </Typography>
          <p>
            Bitte bringen Sie Ihren Personalausweis/Reisepass und die gerichtliche Ladung mit. Lesen Sie sich zudem vor dem Gerichtstermin die gerichtliche
            Ladung genau durch, um zu überprüfen, ob Sie noch weitere Unterlagen oder Dokumente im Original zum Termin mitnehmen müssen. Notwendige Dokumente
            können zum Beispiel sein: Heiratsurkunde, die Geburtsurkunde Ihres Kindes oder der Ehevertrag.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Einlasskontrollen
          </Typography>
          <p>
            Ähnlich wie beim Einchecken am Flughafen gibt es bei Gericht häufig eine Einlasskontrolle. Sie sollten daher genug Zeit einplanen, um nicht zu spät
            in den Gerichtssaal zu kommen.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Unentschuldigtes Fernbleiben
          </Typography>
          <p>
            Sie haben keine Zeit oder den Zeitpunkt für den Gerichtstermin vergessen? Bitte informieren Sie dann rechtzeitig Ihren Anwalt oder das Gericht
            darüber. Unentschuldigtes Fernbleiben kann vom Gericht geahndet werden.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ablauf des Termins
          </Typography>
          <p>Der Ablauf des Scheidungstermins variiert natürlich je nach Richter, aber folgende Punkte sind immer Bestandteil des Termins:</p>
          <MuiListNativeStyled
            sx={{ listStyleType: "decimal" }}
            listItems={[
              "Der Richter überprüft alle benötigten Dokumente (Personalien, Urkunden, ...)",
              "Ihr Anwalt stellt den Antrag auf Scheidung der Ehe bzw. die Aufhebung der Lebenspartnerschaft.",
              "Sie müssen Aussagen zu folgenden Punkten treffen: Heiratsdatum, Trennungsdatum, ggf. wie die Trennung vollzogen wurde und ob die Ehe gescheitert ist.",
              "Ihr Ehepartner muss diese Aussagen bestätigen, damit die Grundlage für eine rechtswirksame Scheidung gegeben ist.",
              "Der Richter bespricht mit Ihnen weitere Themen wie gemeinsame Kinder und Versorgungsausgleich und setzt den Verfahrenswert für die Scheidung fest, der dann als Grundlage für die Berechnung der Gerichtskosten und der Rechtsanwaltsgebühren dient.",
            ]}
          />
          <p>In der Regel dauert der Scheidungstermin zwischen 10 und 15 Minuten.</p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookDivorceCourtHearing;
